"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zztk = exports.zzt = exports.initReferer = exports.getTFromUA = void 0;
var _cookie = require("./cookie");
var _log = _interopRequireDefault(require("./log"));
var _common = require("./common");
/**
 * 设置t和zz_t
 * @param {number} t
 */
var setT = function setT(t) {
  (0, _cookie.setCookie)({
    t: t,
    zz_t: t
  });
};

/**
 * 设置tk
 * @param {string} t
 */
var setTk = function setTk(tk) {
  (0, _cookie.setCookie)({
    tk: tk
  });
};

/**
 * 匹配t或这zz_t
 */
var matchT = function matchT() {
  return /;\s*(t|zz_t)=\d+\s*;?/g.test(document.cookie);
};

/**
 * 获取到t或zz_t
 */
var getT = function getT() {
  return (0, _cookie.getCookie)('t') || (0, _cookie.getCookie)('zz_t');
};

/**
 * 判断pc端还是移动端
 */
var isPC = function isPC() {
  var UA = navigator.userAgent;
  if (UA.match(/(Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|SymbianOS|ToutiaoMicroApp|AppleWebKit.*Mobile.*)/i)) {
    return false;
  } else {
    return true;
  }
};
var getTFromUA = function getTFromUA() {
  var UA = navigator.userAgent;
  // 转转端内
  if (/58ZhuanZhuan$/g.test(UA)) {
    if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(UA)) {
      return matchT() && +getT() !== 16 && 16 || 16;
    } else {
      // android
      return matchT() && +getT() !== 15 && 15 || 15;
    }
  } else if (/ZhuanZhuanSeller$/g.test(UA)) {
    if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(UA)) {
      return matchT() && +getT() !== 18 && 18 || 18;
    } else {
      // android
      return matchT() && +getT() !== 17 && 17 || 17;
    }
  } else if (/zzhunter$/g.test(UA)) {
    if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(UA)) {
      return matchT() && +getT() !== 73 && 73 || 73;
    } else {
      // android
      return matchT() && +getT() !== 72 && 72 || 72;
    }
  } else if (/yigeapp/g.test(UA)) {
    if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(UA)) {
      return matchT() && +getT() !== 55 && 55 || 55;
    } else {
      // android
      return matchT() && +getT() !== 56 && 56 || 56;
    }
  } else if (/zhaoliangji/g.test(UA)) {
    if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(UA)) {
      return matchT() && +getT() !== 79 && 79 || 79;
    } else {
      // android
      return matchT() && +getT() !== 78 && 78 || 78;
    }
  } else if (/58ua="58app"/g.test(document.cookie) || /WUBA/gi.test(UA)) {
    // 58
    return 21;
  } else if (/ganji/g.test(UA)) {
    // ganji
    return 22;
  } else if (/MicroMessenger/g.test(UA)) {
    // 微信浏览器
    // 小程序环境
    if ((0, _common.isMiniprogram)()) {
      if (+getT() <= 100) {
        (0, _cookie.removeCookie)('t');
        (0, _cookie.removeCookie)('zz_t');
      }
      if (+getT() > 100) {
        (0, _cookie.removeCookie)('PPU');
        (0, _cookie.removeCookie)('ZZU');
        (0, _cookie.removeCookie)('uid');
      }
    }

    // t 值已超出100，此历史遗留逻辑移除，判断移到在小程序内
    // if (+getT() > 100) {
    //   removeCookie('PPU')
    //   removeCookie('ZZU')
    //   removeCookie('uid')
    // }

    return 24;
  } else if (/AlipayClient/gi.test(UA)) {
    // 支付宝
    return 53;
  } else if (/QQTheme\//g.test(UA)) {
    // 手机qq 
    return 145;
  } else if (/MQQBrowser\//g.test(UA)) {
    // 手机qq浏览器
    return 99;
  } else if (/cmblife/gi.test(UA)) {
    // 招商银行
    return 41;
  } else if (/WeiBo/gi.test(UA)) {
    // 微博
    return 40;
  } else if (/aweme/gi.test(UA)) {
    // 抖音
    return 76;
  } else if (/kwai/gi.test(UA)) {
    // 快手
    return 77;
  } else if (/ZHWA/gi.test(UA)) {
    // 租号玩
    return 85;
  } else if (/(DiSpecialDriver)|(ddudriver)/gi.test(UA)) {
    // 滴滴车主app
    return 83;
  } else if (/UCBrowser|UCWEB/gi.test(UA)) {
    // UC浏览器
    return 42;
  } else if (/checkapp/g.test(UA)) {
    if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(UA)) {
      return matchT() && +getT() !== 71 && 71 || 71;
    } else {
      // android
      return matchT() && +getT() !== 70 && 70 || 70;
    }
  } else if (/(MPBank).*(AID)/gi.test(UA)) {
    return 47;
  } else if (/didi.passenger/gi.test(UA)) {
    return 84;
  } else if (/meituangroup/gi.test(UA)) {
    return 86;
  } else if (/fhhwebviewbroswer/gi.test(UA)) {
    return 91;
  } else if (/antutu/gi.test(UA)) {
    return 92;
  } else if (/%E7%BE%8E%E5%9B%A2\/85361/gi.test(UA)) {
    return 86;
  } else if (/AiMeiTuan/gi.test(UA)) {
    return 86;
  } else if (/SFEXPRESSAPP/gi.test(UA)) {
    return 93;
  } else if (/SuYunDriver/gi.test(UA)) {
    // 快狗打车司机APP
    return 94;
  } else if (/suyunUser/gi.test(UA) || /58suyunandroid/gi.test(UA)) {
    //快狗打车司机APP 的ua： IOS版本：suyunUser Android版本：58suyunandroid
    return 95;
  } else if (/IqiyiApp/gi.test(UA)) {
    // 爱奇艺
    return 96;
  } else if (/crmHunter/gi.test(UA)) {
    // crmHunter
    if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(UA)) {
      return matchT() && +getT() !== 88 && 88 || 88;
    } else {
      // android
      return matchT() && +getT() !== 87 && 87 || 87;
    }
  } else if (/mediaCode=SFEXPRESSAPP-iOS-ML/gi.test(UA)) {
    // 顺丰速运APP  ios
    return 151;
  } else if (/mediaCode=SFEXPRESSAPP-Android-ML/gi.test(UA)) {
    // 顺丰速运APP Android
    return 152;
  } else if (/ZZC(Android|IOS)\/black\//gi.test(UA)) {
    // 全球购骑士卡
    return 153;
  } else if (/CoolMarket/gi.test(UA)) {
    // 酷安app
    return 777;
  } else if (/yunmaapp\.NET/gi.test(UA)) {
    // 易校园
    return 165;
  } else {
    // m端 pc端
    if (isPC()) {
      return 37;
    } else {
      return 25;
    }
  }
};
exports.getTFromUA = getTFromUA;
var zzt = function zzt(__t) {
  try {
    if (typeof window !== 'undefined') {
      // 先取参数的值
      // 再从顶层窗口 url 上去 t （iframe）
      // 再从当前 url 参数中取
      // 最后从ua中取
      var t = __t || (0, _common.getQueryFromTop)('__t') || (0, _common.getQuery)('__t') || getTFromUA();
      if (t) {
        setT(t);
        _log.default.info("lego\u521D\u59CB\u5316\uFF0C\u8BBE\u7F6Et\u503C\u5B8C\u6210\uFF0Ct\u503C\u4E3A".concat(t));
      }
    }
  } catch (err) {
    _log.default.warn("lego\u521D\u59CB\u5316\uFF0C\u8BBE\u7F6Et\u503C\u51FA\u73B0\u9519\u8BEF\uFF0C\u9519\u8BEF\u4E3A".concat(err));
  }
};
exports.zzt = zzt;
var zztk = function zztk() {
  try {
    if (typeof window !== 'undefined') {
      // 首先cookies里面取tk, cookies里面的是客户端埋入
      // 如果cookies里面没有从url上取tk, 小程序环境中，只有在url上有tk
      // 如果还没有用idzz或者id58
      var tk = (0, _cookie.getCookie)('tk') || (0, _common.getQuery)('tk') || (0, _cookie.getCookie)('zlj_device_id') || (0, _cookie.getCookie)('idzz') || (0, _cookie.getCookie)('id58') || '';
      if (tk) {
        setTk(tk);
        _log.default.info("lego\u521D\u59CB\u5316\uFF0C\u8BBE\u7F6Etk(token)\u503C\u5B8C\u6210\uFF0Ctk\u503C\u4E3A".concat(tk));
      }
    }
  } catch (err) {
    _log.default.warn("lego\u521D\u59CB\u5316\uFF0C\u8BBE\u7F6Etk\u503C\u51FA\u73B0\u9519\u8BEF\uFF0C\u9519\u8BEF\u4E3A".concat(err));
  }
};
exports.zztk = zztk;
var initReferer = function initReferer() {
  try {
    // 设定 pageUrl 就是 referer
    var pageUrl = (0, _common.getPageUrl)({
      scheme: true
    });
    pageUrl = encodeURIComponent(pageUrl);
    (0, _cookie.setCookie)({
      zzreferer: pageUrl
    });
    _log.default.info("lego\u521D\u59CB\u5316\uFF0C\u8BBE\u7F6Ezzreferer\u503C\u5B8C\u6210\uFF0Czzreferer\u503C\u4E3A".concat(decodeURIComponent(pageUrl)));
  } catch (err) {
    _log.default.warn("lego\u521D\u59CB\u5316\uFF0C\u8BBE\u7F6Ezzreferer\u503C\u51FA\u73B0\u9519\u8BEF\uFF0C\u9519\u8BEF\u4E3A".concat(err));
  }
};
exports.initReferer = initReferer;